import API from './api';

export const register = async (formData) => {
  try {
    console.log('in request');
    const res = await API.post('/auth/register', formData);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const login = async (formData) => {
  try {
    const res = await API.post('/auth/login', formData);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getMe = async (options = {}) => {
  try {
    const res = await API.get('/auth/me');
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const updateDetails = async (formData) => {
  try {
    const res = await API.put('/auth/updatedetails', formData);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const updatePassword = async (formData) => {
  try {
    const res = await API.put('/auth/updatepassword', formData);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const logout = async () => {
  try {
    const res = await API.get('/auth/logout');
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const forgotPassword = async (email) => {
  try {
    const res = await API.post('/auth/forgotpassword', { email });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const resetPassword = async (token, password) => {
  try {
    const res = await API.put(`/auth/resetpassword/${token}`, { password });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const addCoins = async (formData) => {
  try {
    const res = await API.put(`/auth/add-coins`, formData);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const shareCoins = async (formData) => {
  console.log(formData);
  try {
    const res = await API.put(
      `/auth/giveaway-coins/${formData.user}`,
      formData
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const clearNotifications = async () => {
  try {
    const res = await API.put(`/auth/clear-notifications`);
    return res.data;
  } catch (err) {
    throw err;
  }
};
